import React from 'react';
import { Box, DraggableDialog } from '@gogame/components';

import { SendMessageForm } from './SendMessageForm';
import { LoadingContainer, NewChatContainer } from './StyledComponents';

export const NewChat = ({ isLoading, onSubmitMessage, children }) => {
  const handleSubmitMessage = async ({ query }, { resetForm }) => {
    resetForm();
    await onSubmitMessage?.({ query });
  };

  return (
    <LoadingContainer loading={isLoading}>
      <NewChatContainer>
        <Box sx={{ p: 3 }}>{children}</Box>
        <DraggableDialog.Content sx={{ p: 1 }}>
          <SendMessageForm
            onSubmit={handleSubmitMessage}
            isLoading={isLoading}
          />
        </DraggableDialog.Content>
      </NewChatContainer>
    </LoadingContainer>
  );
};
